module.exports = __webpack_public_path__ + "static/img/title-button3.d84cf8e9.png";